define('TavanoTeam.ContactUsForm.Model'
,	[	'Backbone'
    ,	'underscore'
    ,	'Utils'
]
,	function (
    Backbone
    ,	_
    ,	Utils
)
{
    'use strict';

    return Backbone.Model.extend({

        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/ContactUsForm.Service.ss')),
        	validation: {
            firstname: {
                required: true
                ,	msg: _('First Name is required').translate()
            }
            ,	lastname: {
                required: true
                ,	msg: _('Last Name is required').translate()
            }
            ,	email: {
                required: true
                ,	pattern: 'email'
                ,	msg: _('Valid Email is required').translate()
            }
            ,	company: {
                required: true
                ,	msg: _('Company is required').translate()
            }
            ,	help: {
                required: true
                ,	msg: _('Help is required').translate()
            }
        }
        
    });
});
